import React from 'react';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const BottomMenu = () => {
    const navigate = useNavigate();
    const { logout } = useAuth();
    const handleLogout = async () => {
        try {
            await logout();
        } catch (error) {
            console.error('Error during logout:', error);
        }
    };
    return (
        <nav className="bottom-menu">
            <button
                className="bottom-menu-item"
                onClick={() => navigate('/')}
            >
                <HomeOutlinedIcon />
                <span>خانه</span>
            </button>

            <button
                className="bottom-menu-item danger"
                onClick={handleLogout}
            >
                <LogoutOutlinedIcon />
                <span>خروج</span>
            </button>
        </nav>
    );
};

export default BottomMenu;
